module.exports = __webpack_public_path__ + "img/first_therapy.0870b973.svg";